import { LinkListPage, LinkListRoute } from "../LinkListPage";
import "../../styles/LinkListPage.scss";
import { useMessagesArray } from "./MessagesElements";
import { useUpdateShowClue } from "../../redux/ShowClue";

export function MessagesApp() {
  useUpdateShowClue(true);
  const availablesMessages = useMessagesArray();

  const messagesList = availablesMessages
    ? availablesMessages.map((d) => d.infos)
    : undefined;

  return (
    <LinkListPage
      title="Messages"
      baseUrl="home/messages"
      links={messagesList}
    />
  );
}

export function MessagesRoute() {
  const array = useMessagesArray();
  return <LinkListRoute array={array} />;
}
